export const headersExportAbsenteeismSupport = [

    { v: "Identificación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Nombre completo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Compañía", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha de Ingreso", t: "s", s: { font: { sz: 12, bold: true } } }, // <-- NUEVO
    { v: "Área", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Cargo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Centro de Costo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Días", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Base", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Entidad de Salud", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Emisor Ausentismo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Tipo de Ausentismo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Detalle de Ausentismo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Código CIE", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Inicio", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Fin", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Observación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Estado", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Usuario Creación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Creación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Usuario Actualización", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Actualización", t: "s", s: { font: { sz: 12, bold: true } } }
];